<template>
    <cancel></cancel>

    <div class="golf">
        <div class="container">
            <div class="page-intro">
                <h1 style="text-transform:none">BOOK A SPA TREATMENT</h1>
            </div>

            <div class="mb-4">
                <spa-treatment-progress-bar></spa-treatment-progress-bar>
            </div>


            
            <div v-if="canShowBar">
                <spa-booking-summary v-bind:isSpaDay="false"></spa-booking-summary>

            </div>
        </div>
        <router-view></router-view>
    </div>

</template>
<script>
    import Cancel from '@/shared/components/Cancel.vue';
    import SpaTreatmentProgressBar from '../components/SpaTreatmentProgressBar.vue';
    import SpaBookingSummary from '../components/SpaBookingSummary.vue';


    export default {
        name: 'SpaTreatmentBooking',
        components: {
            Cancel,
            SpaTreatmentProgressBar,
            SpaBookingSummary
 
        },
        computed: {
            canShowBar() {
                let route = this.$route.name;
                var hidden = route === 'spa_treatment_search' || route === 'spa_treatment_guests' 
                    || route === 'spa_treatment_details' || route === 'spa_treatment_summary';

                return !hidden;

            }
        },
      
    }
</script>
<style src="@/css/booking/booking.css"></style>